Summary candidate profile information.
